// utils/useDeviceDetect.js
import React, {useLayoutEffect} from "react";

export default function useDeviceDetect() {
  const [isMobile, setMobile] = React.useState(false);

  React.useEffect(() => {
    window.addEventListener("resize", () => {
      let width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
      if (width < 800){
        setMobile(true);
      } else {
        setMobile(false);
      }
    });
  }, []);


  React.useEffect(() => {
    const userAgent =
      typeof window.navigator === "undefined" ? "" : navigator.userAgent;
    let mobile = Boolean(
      userAgent.match(
        /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i
      )
    );

    if (!mobile){
      let width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
      if (width < 800){
        mobile = true;
      }
    }

    setMobile(mobile);
  }, []);
  return { isMobile };
}
